<template>
  <div id="app">
  
    <form method="post" style="display:none" :action="(Urlpath == '/' ? '' : Urlpath)+'/Api/System/ExportPDF'" id="__PrintPDF">
        <input name="HTML" id="__PrintPDFHTML">
        <input name="Name" id="__PrintPDFName">
    </form>
    
    <router-view></router-view>
  </div>
</template>

<script>
var self
  export default {
    name: 'app',
    data() {
      return { 
        msg: '',
        openWindows: [],
        thisWindow: {},
        routes: [],
        Index: 1,
          $Urlpath: window._$Urlpath,
				Urlpath: window._$Urlpath,
      }
    },
    mounted(){
       //setRem()
    },
    created() {
      window.rootVue = this;
      var y$set = window.rootVue.$set;
      window.rootVue.$set = function(ydata,f,data){
          if(window.IsNotRootSet){
              window.IsNotRootSet =false;
              return;
          }
          y$set(ydata,f,data)
      }

      self =this;
    },
    updated(){
         console.log('updated')
    },
    methods: {
      getIndex() {
        this.Index++;
        return this.Index;
      },
      setThisWindowVueComponent(Component) {
        if (self.thisWindow) {
          self.thisWindow.vue = Component;
        }
      },
       getThisWindowVueComponent(){ //获取当前窗口的 VueComponent
            if(self.thisWindow){
               return self.thisWindow.vue;
            }
            return null
       },
       getThisWindow() { //获取当前窗口的 thisWindow
        return self.thisWindow
      },
    }
  }
  //  function setRem() {
  //     var whdef = 100/1920;// 表示1920的设计图,使用100PX的默认值
  //     var bodyWidth = document.body.clientWidth;// 当前窗口的宽度
  //     var rem = bodyWidth * whdef;// 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  //     document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
  //   }
  //   window.addEventListener('load', setRem);
  //   window.addEventListener('resize', setRem);
</script>

<style>
  #app {
    height: 100%;
  }
  .el-button{
    font-size: 13px !important;
  }

</style>




// WEBPACK FOOTER //
// App.vue?d70b3df0